import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'
import type { AdverseCredit } from '@/types/adverseCredit'

const verifyAdverseCreditMutation = gql`
  mutation verifyAdverseCredit(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $adverseCredit: [AdverseCreditInput!]!
    $identityConfirmed: Boolean
    $residencyConfirmed: Boolean
  ) {
    verifyAdverseCredit(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      adverseCredit: $adverseCredit
      identityConfirmed: $identityConfirmed
      residencyConfirmed: $residencyConfirmed
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  adverseCredit: AdverseCredit[]
  identityConfirmed: boolean
  residencyConfirmed: boolean
}

export type VerifyAdverseCreditData = {
  verifyAdverseCredit: string | unknown
}

export const useVerifyAdverseCreditMutation: WrappedMutation<
  VerifyAdverseCreditData,
  MutationVars
> = () =>
  useMutation<VerifyAdverseCreditData, MutationVars>(verifyAdverseCreditMutation, {
    client: agentClient,
  })
